import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";

import EmissionAndSequenceSettings from "./ElectronicInvoice/EmissionAndSequenceSettings";
import ElectronicSignatureSettings from "./ElectronicInvoice/ElectronicSignatureSettings";

const tdLabelSx = {
  width: 380,
  bgcolor: "#f3f3f3",
  borderRight: "1px solid #e0e0e0",
  color: "#333",
  fontWeight: 700,
  verticalAlign: "top",
};

const tdFieldSx = { p: 1.5, verticalAlign: "middle" };
const noteSx = { color: "#666", fontSize: 12, lineHeight: 1.25 };

function getCSRF() {
  const name = "csrftoken=";
  const parts = decodeURIComponent(document.cookie || "").split(";");
  for (const p of parts) {
    const t = p.trim();
    if (t.indexOf(name) === 0) return t.substring(name.length);
  }
  return "";
}

export default function ElectronicInvoice() {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [firmaEstado, setFirmaEstado] = useState({
    subida: false,
    valido_hasta: "",
    valido_desde: "",
    valida: false,
    error_clave: false,
  });

  const [firmadoAutomatico, setFirmadoAutomatico] = useState(false);
  const [puntos, setPuntos] = useState([]);
  const [secuenciales, setSecuenciales] = useState([]);

  const refreshEstado = async () => {
    try {
      const r = await fetch("/facturas/firmasec/estado/", { credentials: "include" });
      const j = await r.json();
      if (r.ok) {
        setFirmaEstado(j.firma || {});
        setFirmadoAutomatico(!!j.firma?.firmado_automatico);
        setPuntos(j.puntos || []);
        setSecuenciales(j.secuenciales || []);
      }
    } catch {}
  };

  useEffect(() => {
    refreshEstado();
  }, []);

  return (
    <Paper sx={{ p: 0, borderRadius: "12px", overflow: "hidden", boxShadow: "0 6px 18px rgba(0,0,0,0.1)" }}>
      <Box sx={{ bgcolor: "#f3f3f3", borderBottom: "1px solid #e0e0e0", p: 1.5 }}>
        <Typography sx={{ fontWeight: 800, color: "#333" }}>Datos Generales</Typography>
      </Box>

      <Table sx={{ "& td": { borderBottom: "1px solid #eaeaea" } }}>
        <TableBody>
          <TableRow>
            <TableCell sx={tdLabelSx}>
              Límite Documentos Electrónicos
              <Box sx={noteSx}>(Límite mensual de documentos emitidos)</Box>
            </TableCell>
            <TableCell sx={tdFieldSx}><Typography>Ilimitado</Typography></TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>
              Cupo Disponible
              <Box sx={noteSx}>(Cupo disponible para emitir)</Box>
            </TableCell>
            <TableCell sx={tdFieldSx}><Typography>Ilimitado</Typography></TableCell>
          </TableRow>

          <ElectronicSignatureSettings
            firmaEstado={firmaEstado}
            firmadoAutomatico={firmadoAutomatico}
            onToggleAuto={setFirmadoAutomatico}
            onRefresh={refreshEstado}
            getCSRF={getCSRF}
            setSuccessMessage={setSuccessMessage}
            setErrorMessage={setErrorMessage}
          />

          <EmissionAndSequenceSettings
            puntos={puntos}
            secuenciales={secuenciales}
            onRefresh={refreshEstado}
            getCSRF={getCSRF}
            setSuccessMessage={setSuccessMessage}
          />
        </TableBody>
      </Table>

      <Snackbar
        open={!!successMessage}
        autoHideDuration={3000}
        onClose={() => setSuccessMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="success">{successMessage}</Alert>
      </Snackbar>

      <Snackbar
        open={!!errorMessage}
        autoHideDuration={3500}
        onClose={() => setErrorMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
    </Paper>
  );
}
